import { apiRequest } from "../client";
import type { ReportConfig } from "./types";

/**
 * Payload for creating a single report configuration
 */
export interface ReportConfigPayload {
  name: string;
  data: Record<string, unknown>;
}

/**
 * Response item from batch config creation
 */
export interface BatchConfigResponseItem {
  config_id: string;
  name: string;
}

/**
 * Get report configuration by ID
 */
export const getReportConfig = async (
  configId: string
): Promise<ReportConfig> => {
  return apiRequest<ReportConfig>({
    method: "GET",
    url: `/report-configs/${configId}`,
  });
};

/**
 * Create a new report configuration
 */
export const createReportConfig = async (payload: {
  name: string;
  data: any;
}): Promise<ReportConfig> => {
  return apiRequest<ReportConfig>({
    method: "POST",
    url: `/report-configs`,
    data: payload,
  });
};

/**
 * Create multiple report configurations in a single API call.
 * Reduces API calls from N to 1 when running batch reports.
 *
 * @param configs - Array of config payloads to create
 * @returns Array of created config references with config_id and name
 */
export const createReportConfigsBatch = async (
  configs: ReportConfigPayload[]
): Promise<BatchConfigResponseItem[]> => {
  const response = await apiRequest<{ configs: BatchConfigResponseItem[] }>({
    method: "POST",
    url: `/agentic/report-configs/batch`,
    data: { configs },
  });
  return response.configs;
};
